import { atom } from "recoil";

export const addStateEmployementType = atom({
  key: "addStateEmployementType",
  default: false,
});
export const editStateEmployementType = atom({
  key: "editStateEmployementType",
  default: false,
});
export const rowEditIdStateEmployementType = atom({
  key: "rowEditIdStateEmployementType",
  default: null,
});
export const disableButtonStateEmployementType = atom({
  key: "disableButtonStateEmployementType",
  default: false,
});

export const selectedRowsStateEmployementType = atom({
  key: "selectedRowsStateEmployementType",
  default: [],
});

export const setFilterTextEmploymentType = atom({
  key: "setFilterTextEmploymentType",
  default: "",
});
